<template>
  <button
    v-scroll-to="{ el: 'body' }"
    class="button"
  >
    <span class="button__text">上に戻る</span>
    <icon-angle-bracket
      :is-thin="true"
      class="button__icon"
      direction="top"
    />
  </button>
</template>

<script>
import '@/mikan/_shared/plugins/vueScrollto';
import IconAngleBracket from '@/mikan/_shared/components/atoms/icons/IconAngleBracket.vue';

export default {
  components: {
    IconAngleBracket,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/pc/base/constants';

.button {
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background-color: $color-orange;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  color: $color-white;
  line-height: 1;
  transition: background-color $transition-base;

  &:hover {
    background-color: $color-orange-dark;
    cursor: pointer;
  }

  &__text {
    flex: 0 0 auto;
    font-size: $size-s;
    font-weight: bold;
  }

  &__icon {
    flex: 0 0 auto;
    font-size: $size-l;

    &:nth-child(n + 2) {
      margin-left: 12px;
    }
  }
}
</style>
